import SalesSuppliersMSTAddPage from './SalesSuppliersMSTAddPage';

export default SalesSuppliersMSTAddPage;
